import { AdditionalReasonFieldProps } from './AdditionalReasonField'
import FitOption from '@components/ui/FitOption'
import additionalFieldsStyles from './additionalFields.module.scss'

export const Radios = ({
  field,
  values,
  handleOnAdditionalReasonSelection
}: AdditionalReasonFieldProps) => {
  const handleSelect = (id: string) => {
    const valuesIds = field?.values.map(item => item.id)
    const newValues = values.reason_detail?.filter(
      detailId => !valuesIds?.includes(detailId)
    )
    if (newValues) {
      newValues.push(id)
      handleOnAdditionalReasonSelection(newValues)
    }
  }
  return (
    <div className={additionalFieldsStyles.returnsForm__additionalFieldsRadios}>
      {field?.values.map(item => (
        <FitOption
          key={item.id}
          optionValue={item.label}
          onSelect={() => handleSelect(item.id)}
          selected={values.reason_detail?.includes(item.id)}
          active
          classes={additionalFieldsStyles.returnsForm__additionalFieldsRadio}
        />
      ))}
    </div>
  )
}
